import React from 'react';
import { useSelector } from "react-redux";

const SearchForm = (props) => {
  const statusCd = useSelector((state) => state.mcode.data.status);
  const {
    cd,
    setCd
  } = props;

  const handleChange = (e) => {
    setCd(e.target.value);
  }

  return (
    <select name="cd" value={cd} onChange={handleChange}>
      {statusCd && statusCd.map((status_cd) => (
        <option
          key={status_cd.cd}
          value= {status_cd.cd}
        >{status_cd.code_value1}</option>
      ))}
    </select>
  );
};

export default SearchForm;
